import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, ZapIcon } from 'lucide-react';
export function MechanismSection() {
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-sage-light/40 relative overflow-hidden" data-id="element-105">
      <div className="max-w-5xl mx-auto" data-id="element-106">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center" data-id="element-107">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} data-id="element-108">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white text-sage-dark text-sm font-medium mb-6 shadow-sm border border-sage-light" data-id="element-109">
              <ShieldCheckIcon className="w-4 h-4" data-id="element-110" />
              <span data-id="element-111">Biología aplicada, no magia</span>
            </div>

            <h2 className="text-3xl sm:text-4xl font-heading font-bold text-brown mb-6 leading-tight" data-id="element-112">
              Presentamos el Protocolo Cortisol-Zero
            </h2>

            <div className="space-y-4 text-lg text-brown-light mb-8" data-id="element-113">
              <p data-id="element-114">
                A diferencia de otros métodos, este protocolo activa el{' '}
                <strong className="text-brown" data-id="element-115">Nervio Vago</strong> y el sistema
                parasimpático de forma inmediata.
              </p>
              <p data-id="element-116">
                Mediante{' '}
                <strong className="text-sage-dark" data-id="element-117">
                  3 pasos físicos específicos
                </strong>
                , le enviamos una señal directa a tu cerebro de que el peligro
                ha pasado.
              </p>
              <p className="italic text-brown border-l-4 border-sage pl-4 py-1" data-id="element-118">
                La calma no es algo que esperas; es algo que tú activas.
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} className="relative" data-id="element-119">
            {/* Connecting line */}
            <div className="absolute left-6 top-10 bottom-10 w-0.5 bg-sage-light hidden sm:block" data-id="element-120"></div>

            <div className="space-y-8 relative" data-id="element-121">
              {[{
              number: '1',
              title: 'Activa',
              description: 'Técnica de estimulación vagal específica que envía una señal directa a tu cerebro.'
            }, {
              number: '2',
              title: 'Regula',
              description: 'Tu sistema nervioso pasa de modo "alerta" a modo "calma". El cortisol comienza a bajar.'
            }, {
              number: '3',
              title: 'Respira',
              description: 'En menos de 120 segundos, la crisis se detiene. Tú recuperas el mando.'
            }].map((step, index) => <motion.div key={index} initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.2
            }} className="flex gap-6 relative" data-id="element-122">
                  <div className="flex-shrink-0 w-12 h-12 rounded-full bg-sage text-white flex items-center justify-center font-heading font-bold text-xl shadow-lg shadow-sage/30 relative z-10" data-id="element-123">
                    {step.number}
                  </div>
                  <div className="pt-2" data-id="element-124">
                    <h3 className="text-xl font-heading font-bold text-brown mb-2" data-id="element-125">
                      Paso {step.number}: {step.title}
                    </h3>
                    <p className="text-brown-light leading-relaxed" data-id="element-126">
                      {step.description}
                    </p>
                  </div>
                </motion.div>)}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}